import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'edit_card_user_data';

export const useEditCardUserDataTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    toast_success: 'Карточка успешно обновлена',
    title: 'Редактировать карточку',
    label: 'ФИО',
    submit: 'Сохранить',
    cancel: 'Отмена',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    toast_success: 'Card successfully updated',
    title: 'Edit card',
    label: 'Full name',
    submit: 'Save',
    cancel: 'Cancel',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    toast_success: 'Tarjeta actualizada con éxito',
    title: 'Editar tarjeta',
    label: 'Nombre completo',
    submit: 'Guardar',
    cancel: 'Cancelar',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    toast_success: 'Cartão atualizado com sucesso',
    title: 'Editar cartão',
    label: 'Nome completo',
    submit: 'Salvar',
    cancel: 'Cancelar',
  },
}) as Record<string, unknown>;
